import axios from 'axios'
import { api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const mdMatrixLegalStore = {
  namespaced: true,
  state: () => ({
    is_loading: false,

    selectedTab: 'legal_doc',
    currentContent: 'kbli',

    badan_usaha: [],
    badan_usaha_active: [],
    legal_doc: [],
    legal_doc_active: [],
    matrix: [],
  }),
  mutations: {
    SET_LOADING(state, status) {
      state.is_loading = status
    },
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
  },
  actions: {
    async onPageLoad({ commit, dispatch, rootState }, payload) {
      try {
        const activeSidebar = payload.value
        commit('UPDATE_DATA', payload)

        switch (activeSidebar) {
          case 'legal-doc':
            // dispatch('getKbli')
            break

          default:
            break
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getBadanUsaha({ commit, state }) {
      try {
        const url = `${api}/api/v1/badan-usaha?page=1&limit=2000&`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'badan_usaha',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getBadanUsahaActive({ commit, state }) {
      try {
        const url = `${api}/api/v1/badan-usaha?page=1&limit=2000&is_active=1&order_by=type_pendaftaran_id&order_type=asc`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'badan_usaha_active',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getMatrix({ commit, state }) {
      try {
        const url = `${api}/api/v1/md-matrix-legal?page=1&limit=100000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'matrix',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        if (err.response.status != 404) {
          await commit(
            'SET_NOTIF',
            mixin.methods.$get(err, 'response.data.message', 'Error'),
            { root: true }
          )
        }
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getLegalDocument({ commit, state }) {
      try {
        const url = `${api}/api/v1/legal-document?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'legal_doc',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getLegalDocumentActive({ commit, state }) {
      try {
        const url = `${api}/api/v1/legal-document?page=1&limit=2000&is_active=1`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'legal_doc_active',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async updateBadanUsaha({ commit, state }, payload) {
      try {
        const url = `${api}/api/v1/badan-usaha/${payload.id}`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'PUT',
          url,
          data: payload.data,
        })

        if (data && data.status == 'success') {
          await commit('SET_GLOBAL_LOADING', false, { root: true })
          await commit('SET_NOTIF', 'Data berhasil diubah', { root: true })
          return true
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getAll({ commit, dispatch }) {
      try {
        await dispatch('getBadanUsaha')
        await dispatch('getBadanUsahaActive')
        await dispatch('getMatrix')
        await dispatch('getLegalDocument')
        await dispatch('getLegalDocumentActive')
      } catch (error) {}
    },
  },
}

export default mdMatrixLegalStore
